import React from "react";
import { STATUS_CONFIG } from "@/lib/api";

export function StatusBadge({ status, testId }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.gefunden;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-sm border px-2.5 py-1 text-xs font-semibold tracking-wide ${cfg.className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot} animate-soft-pulse`} />
      {cfg.label}
    </span>
  );
}
